<!--
 * @Description:
 * @version:
 * @Author: guanbw_sr
 * @Date: 2023-02-06 16:33:27
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-09-08 13:46:30
-->
<template>
  <div class="wrapper">
    <div :class="['footer-bar', isCollapse ? 'no-sider' : '', wid ? 'wid0' : 'wid1']">
      <a href="http://beian.miit.gov.cn/" target="_blank">吉 ICP 备 17008829 号-1 </a>
      <x-file-icon class="guohui" :type="'guohui'" :width="'16px'"></x-file-icon>
      <a target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=22017102000237" style="display:inline-block;text-decoration:none;">
          吉公网安备 22017102000237 号
      </a>
      ©2020中国第一汽车集团有限公司 版权所有
    </div>
  </div>
</template>
<script>
  import { mapState } from 'pinia'
  import { pinias } from '@main/common/pinia'

  const { settings } = pinias
  export default {
    name: 'FooterView',
    props: {
      wid: {
        type: Boolean,
        default: true
      },
    },
    computed: {
      ...mapState(settings, ['sidebar']),
      isCollapse() {
        return !this.sidebar.opened
      }
    },
    data() {
      return {
      }
    },
  }
</script>
<style lang="scss" scoped>
  .wrapper {
    padding-left: 10px;
    .footer-bar {
      height: 20px;
      line-height: 20px;
      position: fixed;
      bottom: 0px;
      z-index: 999;
      text-align: right;
      background-color: #fff;
      &.no-sider {
        width: calc(100% - 87px);
      }
    }
  }
  .wid0 {
    width: calc(100% - 240px);
  }
  .wid1 {
    width: 100%
  }

  .guohui {
    vertical-align: middle;
  }
</style>
